/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';

import { ListSubheader, List, lighten, darken } from '@mui/material';
import { useLocation, matchPath } from 'react-router-dom';
import SidebarMenuItem from './item';
import { styled } from '@mui/material/styles';
import { useAppSelector } from 'src/store';
import { MenuItem, MenuItems } from 'src/models/Menu/menu.item';
import AppsIcon from '@mui/icons-material/Apps';
import {
  Bolt,
  CorporateFare,
  Dehaze,
  HomeWork,
  ListAlt,
  RoomPreferences,
  ViewList,
  ViewModule,
  AddBusiness,
  Calculate,
  Bloodtype,
  Vaccines,
  Warehouse,
  FlightLand,
  FlightTakeoff,
  Circle,
  ProductionQuantityLimits,
  PersonAddDisabled,
  ScheduleSend,
  VolunteerActivism,
  Email
} from '@mui/icons-material';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import Group from '@mui/icons-material/Group';
import TranslateIcon from '@mui/icons-material/Translate';
import SafetyDividerIcon from '@mui/icons-material/SafetyDivider';
import BadgeIcon from '@mui/icons-material/Badge';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom';
import GppBadIcon from '@mui/icons-material/GppBad';
import CampaignIcon from '@mui/icons-material/Campaign';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { StethoscopeIcon } from 'src/components/Icons/stethoscope';
import { Divider, Typography } from 'src/components';
import { CustomThemeContext } from 'src/theme/ThemeProvider';
import { customNavMode } from 'src/theme/custom.types';
import { EventNote } from '@mui/icons-material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DiscountIcon from '@mui/icons-material/Discount';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import QrCode from '@mui/icons-material/QrCode';
import VwKullaniciRolyetkiDTO from 'src/models/RolYetki/VwKullaniciRolyetkiDTO';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import InsightsIcon from '@mui/icons-material/Insights';
import PublicIcon from '@mui/icons-material/Public';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import BarChartIcon from '@mui/icons-material/BarChart';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ScienceIcon from '@mui/icons-material/Science';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BiotechIcon from '@mui/icons-material/Biotech';
import ArticleIcon from '@mui/icons-material/Article';
import ArchiveIcon from '@mui/icons-material/Archive';
import StorageIcon from '@mui/icons-material/Storage';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CalculateIcon from '@mui/icons-material/Calculate';
import TableChartIcon from '@mui/icons-material/TableChart';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import BusinessIcon from '@mui/icons-material/Business';
import DescriptionIcon from '@mui/icons-material/Description';
import HotelIcon from '@mui/icons-material/Hotel';
import PaymentIcon from '@mui/icons-material/Payment';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import EmailIcon from '@mui/icons-material/Email';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import RestoreIcon from '@mui/icons-material/Restore';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import Coronavirus from '@mui/icons-material/Coronavirus';
import { translate } from 'src/i18n/tHelper';
import { useGetLanguageByNamespaceQuery } from 'src/services/Base/LanguageApi';
import CircularProgress from 'src/components/CircularProgress';

export const getMenuItemIcon = (yetkikodu: string) => {
  if (!yetkikodu) return <></>
  switch (yetkikodu) {
    case 'HASTAKAYIT':
      return SupervisedUserCircleIcon;
    case 'VEZNE':
      return AlignVerticalBottomIcon;
    case 'TEDAVI':
      return StethoscopeIcon;
    case 'RANDEVU':
      return EventNote;
    case 'FATURAMODUL':
      return ReceiptLongIcon;
    case 'FATURA':
      return ReceiptIcon;
    case 'FATURAIZLEME':
      return QueryStatsIcon;
    case 'FATURAKURUMICMALLERI':
      return CorporateFareIcon;
    case 'GENELTANIMLAR':
      return SettingsIcon;
    case 'VERIKONTROL':
      return PlaylistAddCheckIcon;
    case 'PERSONELTANIM':
      return Group;
    case 'KULLANICITANIM':
      return Group;
    case 'PARAMETRETANIM':
      return SafetyDividerIcon;
    case 'SERVISTANIM':
      return RoomPreferences;
    case 'SERVISPERSONEL':
      return RoomPreferences;
    case 'BRANSTANIM':
      return RoomPreferences;
    case 'KURUMTANIM':
      return HomeWork;
    case 'MODULTANIM':
      return ViewModule;
    case 'KURUMTARIFE':
      return HomeWorkIcon;
    case 'TARIFEISLEM':
      return HomeWorkIcon;
    case 'UCRETTARIFE':
      return HomeWorkIcon;
    case 'VEZNETANIM':
      return AppRegistrationIcon;
    case 'FATURATANIM':
      return LocalOfferIcon;
    case 'INDIRIMTANIM':
      return DiscountIcon;
    case 'DILISLEM':
      return TranslateIcon;
    case 'TETKIKTANIMLARI':
      return BuildCircleIcon;
    case 'ISLEMTANIM':
      return CorporateFare;
    case 'ISLEMBOLUM':
      return Dehaze;
    case 'ISLEMPANEL':
      return ListAlt;
    case 'HIZMETPAKET':
      return ListAlt;
    case 'YETKILENDIRMELER':
      return AdminPanelSettingsIcon;
    case 'YETKITANIM':
      return Bolt;
    case 'ROLTANIM':
      return BadgeIcon;
    case 'ROLYETKI':
      return ControlPointDuplicateIcon;
    case 'KULLANICIROL':
      return Group;
    case 'ORGYETKI':
      return CorporateFareIcon;
    case 'ISLEMLER':
      return SettingsIcon;
    case 'KURUMBONUSTANIM':
      return BusinessIcon;
    case 'DUYURU':
      return CampaignIcon;
    case 'REZERVBARKOD':
      return QrCode;
    case 'DRHAKEDIS':
      return Calculate;
    case 'ISTEMPANELGORUNTULE':
      return ViewList;
    case 'LABIZLEM':
      return Bloodtype;
    case 'ORGANIZASYONTARIFE':
      return AddBusiness;
    case 'KULLANICITARIFE':
      return PersonAddDisabled;
    case 'LOGERROR':
      return GppBadIcon;
    case 'ECZANESTOK':
      return Vaccines;
    case 'DEPODURUM':
      return OtherHousesIcon;
    case 'DEPOTANIMLARI':
      return Warehouse;
    case 'DEPODONEMLERI':
      return Circle;
    case 'URUNTANIMLARI':
      return ProductionQuantityLimits;
    case 'GIRISISLEMLERI':
      return FlightLand;
    case 'CIKISISLEMLERI':
      return FlightTakeoff;
    case 'DEPOTALEPKABUL':
      return ViewStreamIcon;
    case 'ORDERTALEPKABUL':
      return ViewListIcon;
    case 'DEPOTALEP':
      return ScheduleSend;
    case 'VEZNEMODUL':
      return MonetizationOnIcon;
    case 'VEZNEMAKBUZIZLEME':
      return ReceiptIcon;
    case 'KARARDESTEK':
      return InsightsIcon;
    case 'MURACAATIZLEM':
      return TrackChangesIcon;
    case 'KURUMDISI':
      return PublicIcon;
    case 'KURUMDISIHASTAKAYIT':
      return PersonAddIcon;
    case 'KURUMDISIKARGOKURYEISLEMLERI':
      return LocalShippingIcon;
    case 'KURUMDISIRAPORISTATISTIK':
      return BarChartIcon;
    case 'KURUMDISIMURACAATIZLEM':
      return VisibilityIcon;
    case 'YATISKABUL':
      return LocalHospitalIcon;
    case 'PATOLOJIMODUL':
      return ScienceIcon;
    case 'PATOLOJINUMUNEKABUL':
      return AssignmentTurnedInIcon;
    case 'PATOLOJILABORATUVARISLEMLERI':
      return BiotechIcon;
    case 'PATOLOJIRAPORISLEMLERI':
      return ArticleIcon;
    case 'PATOLOJIARSIVLEME':
      return ArchiveIcon;
    case 'PATOLOJIARSIVLEMEDOLAPTANIM':
      return StorageIcon;
    case 'PATOLOJIARSIVLEMEARSIVHAREKET':
      return MoveToInboxIcon;
    case 'PATOLOJIHASTARAPORSONUCLARI':
      return AssessmentIcon;
    case 'PATOLOJIRAPORKURTAR':
      return RestoreIcon;
    case 'RADYOLOJIMODUL':
      return InsightsIcon;
    case 'RADYOLOJICIHAZTANIM':
      return DevicesOtherIcon;
    case 'RADYOLOJICIHAZTESTTANIM':
      return CheckCircleIcon;
    case 'RADYOLOJIRANDEVUSABLON':
      return EventNoteIcon;
    case 'RADYOLOJICIHAZRANDEVU':
      return CalendarTodayIcon;
    case 'RADYOLOJIKABUL':
      return ThumbUpIcon;
    case 'RADYOLOJIISLEMLER':
      return SettingsIcon;
    case 'MUHASEBEMODUL':
      return AccountBalanceIcon;
    case 'MUHASEBEISLEMLER':
      return CalculateIcon;
    case 'HESAPPLAN':
      return TableChartIcon;
    case 'REFERANSDOKTOR':
      return LocalHospitalIcon;
    case 'POSCIHAZTANIM':
      return CreditCardIcon;
    case 'ORG':
      return BusinessIcon;
    case 'DIAGNOSISTANIM':
      return LocalHospitalIcon;
    case 'SERVISPROTOKOLTANIM':
      return DescriptionIcon;
    case 'YATAKTANIM':
      return HotelIcon;
    case 'RAPORTIP':
      return DescriptionIcon;
    case 'VEZNEYETKI':
      return PaymentIcon;
    case 'KULLANICIVTYSYETKI':
      return VpnKeyIcon;
    case 'SONUCIZLEME':
      return FindInPageIcon;
    case 'MAILGONDERIMIZLEME':
      return EmailIcon;
    case 'SABLONTANIM':
      return ImportExportIcon;
    case 'TANITANIM':
      return Coronavirus;
    case 'HEMSIREISLISTE':
      return VolunteerActivism;
    case 'KURUMMAILGONDERIMAYARLARI':
      return Email;
    case 'SONUCIZLEMETANIM':
      return FindInPageIcon;
    default:
      return AppsIcon;
  }
};

const CustomDivider = styled(Divider, {
  shouldForwardProp: (prop) => prop !== 'navMode'
})<{
  navMode?: customNavMode;
}>(
  ({ theme, navMode }) =>
    `
      flex-shrink: 0;
      border-top: 0px solid rgba(0, 0, 0, 0.12);
      border-right: 0px solid rgba(0, 0, 0, 0.12);
      border-left: 0px solid rgba(0, 0, 0, 0.12);
      background-color: transparent;
      height: 0.0625rem;
      border-bottom: none;
      opacity: 0.7;
      background-image: linear-gradient(to right, rgba(52, 71, 103, 0), ${theme.palette.mode === 'dark' || navMode === 'dark'
      ? '#fff'
      : 'rgba(52, 71, 103, 0.4)'
    }, rgba(52, 71, 103, 0)) !important;
`
);
const MenuWrapper = styled(List, {
  shouldForwardProp: (prop) => prop !== 'navMode'
})<{
  navMode?: customNavMode;
}>(
  ({ theme, navMode }) => `
    margin-bottom: ${theme.spacing(1)};
    & > .MuiList-root {
      padding: 0 ${theme.spacing(2)} ${theme.spacing(2)};
    }

    .MuiListSubheader-root {
      font-size: ${theme.typography.pxToRem(12)};
      color: ${navMode === 'dark' ? 'white' : theme.sidebar.textColor};
      padding: ${theme.spacing(0.8, 2)};
    }
`
);

const SubMenuWrapper = styled(List, {
  shouldForwardProp: (prop) => prop !== 'navMode'
})<{
  navMode?: customNavMode;
}>(
  ({ theme, navMode }) => `
    &.MuiList-root {
      padding: 0;
      .MuiList-root .MuiList-root .MuiListItem-root .MuiButton-root {
        font-weight: normal !important;
      }

      .MuiListItem-root {
        padding: 2px ${theme.spacing(2)};
       
        .MuiButton-root {
          display: flex;
          color: ${navMode === 'dark' || theme.palette.mode === 'dark'
      ? 'white'
      : theme.sidebar.textColor
    };
          width: 100%;
          justify-content: flex-start;
          font-size: ${theme.typography.pxToRem(13)};
          padding-top: ${theme.spacing(0.8)};
          padding-bottom: ${theme.spacing(0.8)};
          position: relative;

          .MuiButton-startIcon {
            font-size: ${theme.typography.pxToRem(26)};
            margin-right: ${theme.spacing(1.5)};
          }
          
          .MuiButton-endIcon {
            margin-left: auto;
            font-size: ${theme.typography.pxToRem(22)};
            
          }
          &.MuiParent-active{
            background-color: ${navMode === 'dark' || theme.palette.mode === 'dark'
      ? darken(theme.palette.primary.main, 0.6)
      : lighten(theme.palette.primary.main, 0.8)
    };
          },
          &.Mui-active{
            background-color: ${theme.palette.primary.main};
            color: white;
            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: "#fff";
            }
          },
          &:hover {
            background-color:  ${navMode === 'dark' || theme.palette.mode === 'dark'
      ? darken(theme.palette.primary.main, 0.6)
      : lighten(theme.palette.primary.main, 0.8)
    };
          }
        }

        &.Mui-children {
          flex-direction: column;
          line-height: 1;
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px ${theme.spacing(0)};

            .MuiButton-root {
              font-size: ${theme.typography.pxToRem(13)};

              &.Mui-active{
                background-color: ${theme.palette.primary.main};
                color: white;
              },
              &.Mui-selected{
                background-color: ${theme.palette.primary.main};
                color: white;
                .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: "#fff";
            }
              },
              &:hover {
                background-color:  ${navMode === 'dark' || theme.palette.mode === 'dark'
      ? darken(theme.palette.primary.main, 0.6)
      : lighten(theme.palette.primary.main, 0.8)
    };
              }
            }
          }
        }
      }
    }
`
);
const translatePath = 'common';
const SidebarMenu = (): JSX.Element => {
  const location = useLocation();
  const langQuery = useGetLanguageByNamespaceQuery({ lang: localStorage.getItem("lang"), ns: "translation" }, { refetchOnMountOrArgChange: true });
  const auth = useAppSelector((state) => state.menuAuth);

  const [menuItems, setMenuItems] = useState<MenuItems[]>([]);

  const getMenuItems = (menu: VwKullaniciRolyetkiDTO): Array<MenuItem> => {
    let res: Array<MenuItem>;
    let items = auth.data.filter((i) => i.bagliId === menu.yetkiId);
    if (items.length) {
      res = [];
      items.forEach((i) => {
        let kontrol = res.find((varmi) => varmi.code === i.yetkikodu);
        if (!kontrol) {
          res.push({
            name: i.name ? translate("pages|menu|items", i.yetkiadi)?.toString() : i.yetkiadi,
            code: i.yetkikodu,
            icon: getMenuItemIcon(i.yetkikodu),
            link: i.link,
            id: i.id,
            items: getMenuItems(i)
          });
        }
      });
    }
    return res;
  };
  useEffect(() => {
    if (!langQuery.isFetching) {
      let menuItemsArr: Array<MenuItems> = [];
      if (auth.data.length > 0) {
        let headings = auth.data.filter((f) => f.seviye === 1);
        if (headings.length === 0) return;
        headings.forEach((h) => {
          let headingKontrol = menuItemsArr.find(
            (varmi) => varmi.code === h.yetkikodu
          );
          if (!headingKontrol) {
            let menuItems: MenuItems = {
              heading: h.name ? translate("pages|menu|items", h.yetkiadi) : h.yetkiadi,
              code: h.yetkikodu,
              items: getMenuItems(h)
            };
            menuItemsArr.push(menuItems);
          }
        });
      }
      setMenuItems(menuItemsArr);
    }
  }, [auth, langQuery.isFetching]);

  const themeContext = useContext(CustomThemeContext);
  const renderSidebarMenuItems = ({
    items,
    path
  }: {
    items: MenuItem[];
    path: string;
  }): JSX.Element => {
    return (
      <SubMenuWrapper navMode={themeContext.navMode}>
        {items.reduce((ev, item) => reduceChildRoutes({ ev, item, path }), [])}
      </SubMenuWrapper>
    );
  };
  const reduceChildRoutes = ({
    ev,
    path,
    item
  }: {
    ev: JSX.Element[];
    path: string;
    item: MenuItem;
  }): Array<JSX.Element> => {
    const exactMatch = item.link
      ? !!matchPath(
        {
          path: item.link,
          end: true
        },
        path
      )
      : false;

    if (item.items) {
      const partialMatch = item.link
        ? !!matchPath(
          {
            path: item.link,
            end: false
          },
          path
        )
        : false;
      ev.push(
        <SidebarMenuItem
          key={item.id}
          active={partialMatch}
          open={partialMatch}
          name={item.name}
          icon={item.icon}
          link={item.link}
          badge={item.badge}
          id={item.id}
        >
          {renderSidebarMenuItems({
            path,
            items: item.items
          })}
        </SidebarMenuItem>
      );
    } else {
      ev.push(
        <SidebarMenuItem
          key={item.id}
          active={exactMatch}
          name={item.name}
          link={item.link}
          badge={item.badge}
          icon={item.icon}
          id={item.id}
        />
      );
    }
    return ev;
  };
  return (
    <>
      {langQuery.isFetching ? (
        <CircularProgress
          sx={{
            top: '50%',
            left: '41%',
            position: 'sticky'
          }}
        />
      ) : (
        <>
          {menuItems?.length === 0 && (
            <Typography sx={{ paddingLeft: 2, paddingTop: 10 }}>
              {translate(translatePath, 'Menü Yetkiniz Bulunmamaktadır')}
            </Typography>
          )}
          {menuItems &&
            menuItems.map((section, i) => (
              <div key={i}>
                <MenuWrapper
                  navMode={themeContext.navMode}
                  key={section.heading}
                  subheader={
                    <ListSubheader
                      key={section.heading}
                      component="div"
                      disableSticky
                    >
                      <CustomDivider navMode={themeContext.navMode} />
                      {section.heading}
                    </ListSubheader>
                  }
                >
                  {renderSidebarMenuItems({
                    items: section.items,
                    path: location?.pathname
                  })}
                </MenuWrapper>
              </div>
            ))}
        </>
      )}
    </>
  );
};

export default SidebarMenu;
